import React, { useContext } from 'react'
import { ToolBar, Spacer } from '@sencha/ext-modern'

import { IsDialogContext } from 'tyan/public/components/context'
import Button from './Button'
import Flow from './Flow'
import RecordFlow from './RecordFlow'

export default props => {
	const { controls } = props
	const isDialog = useContext(IsDialogContext)
	return controls && <ToolBar defaults={{ margin: "0 10 0 0" }} ui="app-transparent-toolbar" shadow={false} margin="0 0 0 10" padding="0"
		layout={{ wrap: true }} docked={isDialog ? 'bottom' : 'top'}
	>
		{isDialog && <Spacer /> || null}
		{controls.filter(btn => !btn.cdt || btn.cdt()).map(o => (
			o._button
				? <Button key={'btn_' + o._button} config={o} />
				: o._flow
					? <Flow key={'flow_' + o._flow} config={o} />
					: o._recordflow
						? <RecordFlow key={'recordflow_' + o._recordflow} config={o} />
						: null
		))}
	</ToolBar> || null
}